import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import CartDrawer from "./components/CartDrawer";
import ChatWidget from "./components/ChatWidget";
import WhatsAppFloat from "./components/WhatsAppFloat";
import NewsletterPopup from "./components/NewsletterPopup";
import Home from "./pages/Home";
import Product from "./pages/Product";
import Checkout from "./pages/Checkout";
import SearchPage from "./pages/SearchPage";
import AboutPage from "./pages/AboutPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Contact from "./pages/Contact";
import LegalPage from "./pages/LegalPage";
import AdminShipping from "./pages/AdminShipping";
import AdminHub from "./pages/AdminHub";
import AdminProducts from "./pages/AdminProducts";
import AdminOrders from "./pages/AdminOrders";
import AdminMedia from "./pages/AdminMedia";
import AdminBoxtal from "./pages/AdminBoxtal";
import Gallery from "./pages/Gallery";
import AccountLogin from "./pages/AccountLogin";
import AccountRegister from "./pages/AccountRegister";
import AccountDashboard from "./pages/AccountDashboard";
import CollectionPage from "./pages/CollectionPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import ReviewSubmit from "./pages/ReviewSubmit";
import AdminReviews from "./pages/AdminReviews";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminContent from "./pages/AdminContent";
import AdminMessages from "./pages/AdminMessages";
import AdminNewsletter from "./pages/AdminNewsletter";
import AdminCategories from "./pages/AdminCategories";
import AdminMediaLibrary from "./pages/AdminMediaLibrary";
import AdminEnvois from "./pages/AdminEnvois";
import AdminTeam from "./pages/AdminTeam";
import AuthCallback from "./pages/AuthCallback";
import GiftCardPage from "./pages/GiftCardPage";

// Wraps our routes so we can intercept Google OAuth callbacks (hash-based)
// synchronously during render — playbook requires this to avoid race
// conditions with AuthProvider's own /me check.
function AppRouter({ children }) {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CurrencyProvider>
            <CartProvider>
            <AppRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/parfum/:slug" element={<Product />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/recherche" element={<SearchPage />} />
              <Route path="/a-propos" element={<AboutPage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal/:slug" element={<LegalPage />} />
              <Route path="/connexion" element={<AccountLogin />} />
              <Route path="/inscription" element={<AccountRegister />} />
              <Route path="/compte" element={<AccountDashboard />} />
              <Route path="/collection/:slug" element={<CollectionPage />} />
              <Route path="/lunettes" element={<ComingSoonPage type="lunettes" />} />
              <Route path="/sacs" element={<ComingSoonPage type="sacs" />} />
              <Route path="/avis/:token" element={<ReviewSubmit />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/hub" element={<AdminHub />} />
              <Route path="/admin/content" element={<AdminContent />} />
              <Route path="/admin/messages" element={<AdminMessages />} />
              <Route path="/admin/newsletter" element={<AdminNewsletter />} />
              <Route path="/admin/categories" element={<AdminCategories />} />
              <Route path="/admin/library" element={<AdminMediaLibrary />} />
              <Route path="/admin/team" element={<AdminTeam />} />
              <Route path="/admin/products" element={<AdminProducts />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
              <Route path="/admin/media" element={<AdminMedia />} />
              <Route path="/admin/envois" element={<AdminEnvois />} />
              <Route path="/admin/shipping" element={<AdminShipping />} />
              <Route path="/admin/boxtal" element={<AdminBoxtal />} />
              <Route path="/admin/reviews" element={<AdminReviews />} />
              <Route path="/galerie" element={<Gallery />} />
              <Route path="/carte-cadeau" element={<GiftCardPage />} />
            </Routes>
            </AppRouter>
            <CartDrawer />
            <WhatsAppFloat />
            <ChatWidget />
            <NewsletterPopup />
            <Toaster
              position="bottom-left"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#0A0A0A",
                  border: "1px solid rgba(212,175,55,0.35)",
                  color: "#fff",
                  borderRadius: 0,
                  fontFamily: "Inter, sans-serif",
                  letterSpacing: "0.05em",
                  fontSize: "13px",
                },
              }}
            />
          </CartProvider>
          </CurrencyProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
